/* @generated */

// src/assets/ui-icon/line/settings.tsx
import * as React from "react";
var SettingsLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M12 9a2.811 2.811 0 0 0-3 3 2.811 2.811 0 0 0 3 3 2.81 2.81 0 0 0 3-3 2.813 2.813 0 0 0-3-3Zm0 4.5a1.344 1.344 0 0 1-1.5-1.5 1.344 1.344 0 0 1 1.5-1.5 1.345 1.345 0 0 1 1.5 1.5 1.346 1.346 0 0 1-1.5 1.5Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    d: "M18 12c0-.15-.005-.3-.015-.463l1.389-1.764-1.758-3.045-1.989.286a5.438 5.438 0 0 0-1.09-.565L13.758 4.5h-3.516l-.78 1.95a5.44 5.44 0 0 0-1.09.565l-1.989-.286-1.758 3.045 1.39 1.765a7.405 7.405 0 0 0 0 .925l-1.39 1.764 1.758 3.045 1.989-.286a5.47 5.47 0 0 0 1.09.565l.78 1.948h3.515l.78-1.95a5.44 5.44 0 0 0 1.09-.565l1.99.287 1.757-3.045-1.389-1.766c.01-.161.015-.311.015-.461Zm-1.532-.624a6.276 6.276 0 0 1 0 1.248l-.029.3 1.128 1.434-.742 1.285-1.6-.23-.25.195c-.371.283-.79.498-1.236.636l-.339.106-.658 1.65h-1.484l-.658-1.65-.337-.108a3.974 3.974 0 0 1-1.236-.635l-.25-.195-1.6.23-.743-1.285 1.128-1.433-.028-.3a5.976 5.976 0 0 1-.002-1.248l.028-.3-1.128-1.434.743-1.285 1.6.23.25-.195c.371-.283.79-.498 1.236-.635l.339-.107.658-1.65h1.485l.657 1.65.337.107c.446.138.864.353 1.236.636l.25.195 1.6-.23.742 1.285-1.128 1.433.031.3Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
));
export {
  SettingsLine
};
